interface ReplacesListProps {
  /** Well-known products this arche replaces. */
  items: string[];
  /** Dim the chips slightly (used for not-yet-shipped categories). */
  muted?: boolean;
}

/**
 * Renders the products an arche replaces as a wall of brand chips. This is the
 * emphasized column of the Featured table — the "cancel these subscriptions"
 * story we want investors and users to see at a glance.
 */
export function ReplacesList({ items, muted = false }: ReplacesListProps) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {items.map((name) => (
        <span
          key={name}
          className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${
            muted
              ? 'border-border bg-muted/40 text-muted-foreground'
              : 'border-primary/25 bg-primary/10 text-foreground'
          }`}
        >
          {name}
        </span>
      ))}
    </div>
  );
}
